module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9ce846b427193dfc81e99f6495b535ce.png";